import React from 'react';

interface HelpIconProps {
  size?: number;
  className?: string;
}

export const HelpIcon: React.FC<HelpIconProps> = ({ 
  size = 24,
  className = ""
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9 20H5C4.45 20 3.97933 19.8043 3.588 19.413C3.19667 19.0217 3.00067 18.5507 3 18V4C3 3.45 3.196 2.97933 3.588 2.588C3.98 2.19667 4.45067 2.00067 5 2H19C19.55 2 20.021 2.196 20.413 2.588C20.805 2.98 21.0007 3.45067 21 4V18C21 18.55 20.8043 19.021 20.413 19.413C20.0217 19.805 19.5507 20.0007 19 20H15L12.7 22.3C12.5 22.5 12.2667 22.6 12 22.6C11.7333 22.6 11.5 22.5 11.3 22.3L9 20ZM5 18H9.8L12 20.2L14.2 18H19V4H5V18ZM11.9 17C12.25 17 12.546 16.879 12.788 16.637C13.03 16.395 13.1507 16.0993 13.15 15.75C13.1493 15.4007 13.0283 15.1047 12.787 14.862C12.5457 14.6193 12.25 14.4987 11.9 14.5C11.55 14.5013 11.254 14.6223 11.012 14.863C10.77 15.1037 10.6493 15.3993 10.65 15.75C10.6507 16.1007 10.7717 16.3967 11.013 16.638C11.2543 16.8793 11.55 17 11.9 17ZM13.65 8C13.65 8.28333 13.5583 8.58767 13.375 8.913C13.1917 9.23833 12.8833 9.59233 12.45 9.975C12.1667 10.225 11.9377 10.4627 11.763 10.688C11.5883 10.9133 11.4423 11.1423 11.325 11.375C11.2583 11.5083 11.2083 11.6417 11.175 11.775C11.1417 11.9083 11.1083 12.0583 11.075 12.225C11.0417 12.475 11.1083 12.6917 11.275 12.875C11.4417 13.0583 11.6583 13.15 11.925 13.15C12.1583 13.15 12.3667 13.0667 12.55 12.9C12.7333 12.7333 12.8583 12.5083 12.925 12.225C12.975 11.9917 13.071 11.775 13.213 11.575C13.355 11.375 13.584 11.1167 13.9 10.8C14.4833 10.2167 14.896 9.725 15.138 9.325C15.38 8.925 15.5007 8.48333 15.5 8C15.5 7.1 15.196 6.375 14.588 5.825C13.98 5.275 13.1507 5 12.1 5C11.35 5 10.7 5.15833 10.15 5.475C9.6 5.79167 9.15833 6.23333 8.825 6.8C8.70833 7 8.70433 7.20833 8.813 7.425C8.92167 7.64167 9.09233 7.79167 9.325 7.875C9.54167 7.95833 9.75833 7.95833 9.975 7.875C10.1917 7.79167 10.3667 7.65833 10.5 7.475C10.6833 7.24167 10.9083 7.05433 11.175 6.913C11.4417 6.77167 11.75 6.70067 12.1 6.7C12.5333 6.7 12.9 6.82067 13.2 7.062C13.5 7.30333 13.65 7.616 13.65 8Z"
        fill="currentColor"
      />
    </svg>
  );
};

